import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { AuthServiceService } from '../_services/AuthService.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UserForLogin } from '../_models/UserForLogin';
import { Router } from '@angular/router';
import { AlertifyService } from '../_services/alertify.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  
  @Output() actionChange = new EventEmitter();

  isLoading = false;
  jwtHelper = new JwtHelperService();
  decodedToken: any;

  constructor(private _authService: AuthServiceService, private _router: Router, private _alertify: AlertifyService) { }
  user: UserForLogin = {UserName: "", Password: ""};

  ngOnInit() {
  }

  actionChanged() {
    this.actionChange.emit("register");
  }

  login() {
    this.isLoading = true;
    this._authService.login(this.user).subscribe((data) => {
      this._alertify.success('Logged in successfully')
      this.isLoading = false;
    }, error => {
      this._alertify.error(error);
      this.isLoading = false;
    });
  }

}
